<template>
  <div class="product" :class="[prod.type, prod.background ? `bg-${prod.background}` : '']">
    <div class="content">
      <template v-if="prod.type == 'course'">
          <div
            class="product__image"
            @mouseover="hoveringProduct = true;"
            @mouseout="hoveringProduct = false;"
            :style="[prod.img ? { 'background-image': `url(${require('@/assets/' + prod.img)})` } : '']">
            <transition-group name="slide-fade">
              <div class="order" v-if="hoveringProduct" :key="prod.id">
                <button :key="prod.title" name="TryButton" @click="tryProduct" class="button button--try button--rounded">{{texts.order}}</button>
              </div>
            </transition-group>
          </div>


        <!-- <img class="product__image" :src="require(`@/assets/${prod.img}`)" /> -->
        <div class="product__middle">
          <h2 class="product__title" v-html="prod.title"></h2>
          <p class="product__group"><span>{{texts.pGroup}}</span> {{prod.group}}</p>
          <p class="product__duration">{{prod.duration}}</p>
          <p
            :class="[showReadMore && prod.description.length > maxDescLength ? 'partial' : 'full']"
            class="product__description"
            v-html="prodDescription(prod.description)"></p>

          <div class="order" v-if="!showReadMore || prod.description.length < maxDescLength" :key="prod.id">
            <button :key="prod.title" name="TryButton" @click="tryProduct" class="button button--try button--rounded">{{texts.order}}</button>
          </div>
          <a
            class="product__read-more"
            v-show="prod.description.length > maxDescLength && showReadMore"
            @click="readMore()">>></a>
          <!-- <a
            class="product__read-less"
            v-show="prod.description.length > maxDescLength && !showReadMore"
            @click="showReadMore = !showReadMore"><<</a> -->

          <!-- <button name="TryButton" @click="tryProduct" class="button button--try button--rounded">{{texts.order}}</button> -->
        </div>

        <div class="product__bottom">
          <div class="product__tags"><span>{{texts.cTags}}</span> {{prod.tags.join('&nbsp;&nbsp;')}}</div>
        </div>
      </template>
      <template v-else>

        <div >
          <div class="icon"></div>
          <h2>{{prod.title}}</h2>
          <span>{{prod.duration}}</span>
          <button name="article" class="button button--try button--rounded button--article">Read article</button>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data() {
    return {
      showReadMore: true,
      maxDescLength: 150,
      hoveringProduct: false,
    }
  },
  props: {
    prod: Object,
  },
  computed: {
    state() {
      return this.$root.$data.state;
    },
    texts() {
      return this.state.system.main
    },
  },
  methods: {
    prodDescription(desc) {
      return (!this.showReadMore || desc.length < this.maxDescLength) ? desc : `${desc.substr(0, this.maxDescLength)} ...`;
    },
    tryProduct: function() {
      console.log('Try product window');
      // TODO
      // Here you should be able to select which courses you want to try
      // And add your contact info ([O][X[X] -> e-mail@mail.com -> SEND )
      // this.$emit('tryProduct', this.prod);
      this.$root.$data.showOrder({ orderType: 'single', orderProd: this.prod });
    },
    removeProduct(prod) {
      // console.log(this);
      // console.log(this.prod);
      // this.$emit('removeProduct', this.prod.id);
    },
    resizeGridItem() {
      // console.log("____________");
      let item = this.$el.querySelector('.content').parentElement;
      const grid = document.querySelector('.grid-products');
      const rowHeight = 20;
      const rowGap = 16;
      const rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
      item.style.gridRowEnd = "span " + rowSpan;
    },
    readMore() {
      this.showReadMore = !this.showReadMore;
      // console.log("____________");
      let self = this;
      setTimeout(function() {
        self.resizeGridItem();
      }, 50)
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resizeGridItem);

      //Init
      this.resizeGridItem()
    })
  },
  updated() {
    this.resizeGridItem()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeGridItem);
  }
};
</script>

<style lang="stylus">

@import '../styles/common.styl'

.product
  position relative
  // min-height 300px
  background-color #fff
  border 1px solid #e3e3e3
  margin-bottom 25px
  border-radius 0px 0px 10px 10px
  box-shadow 0px 2px 0px 0px #e3e3e3
  color #666
  // height 100%
  // break-inside avoid-column
  // page-break-inside avoid
  // min-height 575px
  .content
    padding-bottom 120px
  &.article
    border-radius 10px
    height 100%
    min-height 300px
    text-align center
    border none
    padding 0px 50px
    &.bg-yellow
      background-color $OTSyellow
    &.bg-blue
      background-color $OTSblue
    .icon
      display inline-block
      text-align center
      background-image url('../assets/rocket.png')
      height 50px
      width 50px
      margin-top 40px
      margin-bottom 15px
    h2
      color #fff
      font-size 24px
      margin-bottom 20px
      font-weight 500
    span
      display block
      color #fff
      font-size 12px
      margin-bottom 35px
    .button--article
      margin auto
      background-color #fff
      color $OTSred

  /* box-shadow breaking into next column fix */
  &:after
    display block
    content ''
    height 4px
    width 100%
    margin-bottom -2px

  &__middle
    // margin-bottom 100px
    z-index 2
    .order
      margin-top  20px
      // margin-bottom  20px
      padding 0 30px
      .button
        margin 0
  &__image
    position relative
    max-width 319px
    min-height 200px
    // background-color #575757
    background-size cover
    background-repeat no-repeat
    z-index 1
    margin 0 auto
    .order
      position absolute
      height 50%
      width 100%
      bottom 0px
      background-color $OTSred
      .button--try
        background-color #fff
        color $OTSred
        margin auto
        transform translateY(80%)

  &__title
    font-size 24px
    line-height 1.2em
    font-weight 600
    color #333
    padding 28px 30px 6px
    text-transform capitalize
  &__group
    padding 6px 30px
    font-size 12px
  &__duration
    position relative
    padding 6px 30px
    padding-left 56px
    font-size 12px
    &:before
      content ''
      position absolute
      display block
      height 16px
      width 16px
      left 30px
      top 0px
      bottom 2px
      margin auto
      background-image url('../assets/duration_icon.jpg')
  &__description
    padding 15px 30px 0px
    font-size 12px
    line-height 1.3
    margin-bottom 10px
    transition .5s all ease-out
    // max-height 250px
    overflow hidden
    .highlighted
      display block
      color #aa1454
      font-weight 600
      margin-bottom .5em
    &.partial
      max-height 82px
  &__read-more,
  &__read-less
    display inline-block
    margin 0px 30px 15px
    color $OTSred
    cursor pointer
  &__tags
    position absolute
    bottom 0px
    width 100%
    background-color #f6f6f6
    color #666666
    min-height 80px
    padding 25px 30px
    font-size 10px
    line-height 1.6em
    text-transform uppercase
    border-radius 0px 0px 10px 10px
    span
      color #333333
      font-size 12px
      text-transform none

</style>



// WEBPACK FOOTER //
// src/components/Product.vue